<template>
  <div>
    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('chainInoutOrder.queryCondition') }}</div>
      </div>
      <div class="">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              v-model="chainInoutOrderInfo.conditions.personName"
              :placeholder="$t('chainInoutOrder.personNamePlaceholder')"
              clearable
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="chainInoutOrderInfo.conditions.orderId"
              :placeholder="$t('chainInoutOrder.orderIdPlaceholder')"
              clearable
            />
          </el-col>
          <el-col :span="4">
            <el-select
              v-model="chainInoutOrderInfo.conditions.csId"
              :placeholder="$t('chainInoutOrder.supplierPlaceholder')"
              style="width:100%"
            >
              <el-option
                v-for="(cs,index) in chainInoutOrderInfo.css"
                :key="index"
                :label="cs.name"
                :value="cs.csId"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" @click="_queryChainInoutOrderMethod">
              <i class="el-icon-search"></i>
              {{ $t('chainInoutOrder.query') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('chainInoutOrder.orderTitle') }}</div>
      </div>
      <div class="">
        <chain-inout-order-table
          :inout-orders="chainInoutOrderInfo.inoutOrders"
          @to-order-detail="_toOrderDetail"
        />
        <el-pagination
          :current-page="chainInoutOrderInfo.conditions.page"
          :page-size="chainInoutOrderInfo.conditions.row"
          :total="chainInoutOrderInfo.total"
          layout="total, prev, pager, next, jumper"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import ChainInoutOrderTable from '@/components/admin/chainInoutOrder/chainInoutOrderTable'
import { listChainInoutOrder, listChainSuppliers } from '@/api/admin/chainInoutOrder/chainInoutOrderApi'

export default {
  name: 'ChainInoutOrder',
  components: {
    ChainInoutOrderTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      chainInoutOrderInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        moreCondition: false,
        csId: '',
        css: [],
        conditions: {
          personName: '',
          orderId: '',
          csId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listChainInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      this._listChainSuppliers()
    },
    async _listChainInoutOrder(_page, _rows) {
      this.chainInoutOrderInfo.conditions.page = _page
      this.chainInoutOrderInfo.conditions.row = _rows
      try {
        const res = await listChainInoutOrder(this.chainInoutOrderInfo.conditions)
        this.chainInoutOrderInfo.total = res.total
        this.chainInoutOrderInfo.records = res.records
        this.chainInoutOrderInfo.inoutOrders = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _queryChainInoutOrderMethod() {
      this._listChainInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handlePageChange(val) {
      this._listChainInoutOrder(val, this.DEFAULT_ROWS)
    },
    _toOrderDetail(order) {
      console.log(order)
    },
    async _listChainSuppliers() {
      try {
        const res = await listChainSuppliers({ page: 1, row: 50 })
        this.chainInoutOrderInfo.css = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>